import { useApiQuery } from 'src/api';
import { SearchACOPRequest } from './statusCount';
import { useBuildVars } from 'src/config';

export interface AcopSearchRequest extends SearchACOPRequest {
  AcopStatus?: string;
  PageNo: number;
  PageSize: number;
}

export interface AcopDetails {
  acopStatus: string;
  acopTrackingNumber: number;
  bcn: string;
  bidNumber: string;
  branchNo: string;
  bundleId: string;
  createTimestamp: string;
  createdBy: string;
  customerCompanyCode: string;
  customerId: number;
  discountTrackingId: number;
  distNo: string;
  id: string;
  importReferenceId: number;
  lineNumber: string;
  orderDate: string;
  orderLineId: number;
  orderLineQuantity: string;
  orderNo: string;
  orderNumber: string;
  orderShipQuantity: string;
  programName: string;
  quantity: number;
  responseStatus: string;
  responseStatusReason: string;
  shipNo: string;
  skSbo: number;
  sku: string;
  statusCode: string;
  uniqueDiscountTrackingId: number;
  updateTimestamp: string;
  vendorName: string;
}

export interface AcopSearchResponse {
  data: AcopDetails[];
  responsePreamble: {
    currentPage: number;
    hasNext: boolean;
    hasPrevious: boolean;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

export function useGetAcopList(params: AcopSearchRequest) {
  const buildVars = useBuildVars();
  return useApiQuery<AcopSearchResponse>(
    '/system.webapi.gds/api/v1/gdsCoreApiDiscountMaintenance/GetDiscountDetails',
    params,
    undefined,
    undefined,
    { host: buildVars.VP_API_BASE }
  );
}
